import type { BuildHubRoleEnum } from 'generated/graphql';

interface CollaboratorUpdateData {
    buildHubId: string;
    collaboratorId: string;
    role: BuildHubRoleEnum;
    caption?: string;
}

/**
 * Builds FormData for updating a collaborator in BuildHub.
 */
export function buildFormDataForCollaboratorUpdate(
    data: CollaboratorUpdateData
): FormData {
    const formData = new FormData();
    formData.append('buildHubId', data.buildHubId);
    formData.append('collaboratorId', data.collaboratorId);
    formData.append('role', data.role);

    if (data.caption !== undefined) {
        formData.append('caption', data.caption);
    }

    return formData;
}
